import LocationChart from "views/dsp/LocationChart";
import AMCReportTable from "./AMCReportTable";
import { useAMCReportData } from "./hooks/useAMCReportData";
import { Col } from "react-bootstrap";
import { useMemo, useState } from "react";
import { getDSPMetricSpec } from "views/dsp/metrics";
import { useAppSelector } from "redux/hooks";
import { mapCountryCodeToName, mapStateCodeToName } from "./utils";

const AMCGeoReport = ({ reportData, reportDetails, queryDetails }) => {
  const marketplace = useAppSelector((state) => state.marketPlace);
  const [selectedMetric, setSelectedMetric] = useState("total_impressions");

  const { data: dataByState } = useAMCReportData(
    null,
    "DSP_PERFORMANCE_BY_LOCATION_INTERNAL",
    true,
    reportDetails?.id,
    !!reportDetails?.id,
  );

  const metric = useMemo(
    () => getDSPMetricSpec(marketplace.marketPlace, selectedMetric),
    [marketplace, selectedMetric],
  );

  const metricOptions = [
    { value: "total_impressions", label: "Impressions" },
    { value: "unique_reach", label: "Unique Reach" },
    { value: "users_that_clicked", label: "Users that Clicked" },
    { value: "dsp_total_detail_page_views", label: "Detail Page Views" },
    { value: "dsp_total_add_to_cart", label: "Add to Carts" },
    { value: "purchases", label: "Purchases" },
    { value: "total_product_sales", label: "Total Product Sales" },
  ];

  const tableData = useMemo(() => {
    if (!reportData) {
      return [];
    }
    return reportData.map((d) => {
      return {
        state: mapStateCodeToName(d.iso_state_province_code),
        country: mapCountryCodeToName(d.iso_country_code),
        ...d,
      };
    });
  }, [reportData]);

  const geoData = useMemo(() => {
    if (!dataByState) {
      return [];
    }
    return dataByState
      .filter((d) => {
        return d.iso_country_code === "US" && d.iso_state_province_code.split("-")[1];
      })
      .map((d) => {
        return {
          "hc-key": d.iso_state_province_code.toLowerCase(),
          value: metric.accessor(d),
          d,
        };
      });
  }, [dataByState, metric]);

  const regionData = useMemo(() => {
    if (!dataByState) {
      return [];
    }
    return dataByState.map((d) => {
      const region = (mapStateCodeToName(d.iso_state_province_code) || "Other") + ", " + d.iso_country_code;
      return {
        ...d,
        region,
      };
    }, {});
  }, [dataByState]);

  return (
    <>
      <Col xs={12}>
        <LocationChart
          geoData={geoData}
          selectedMetric={selectedMetric}
          metricOptions={metricOptions}
          onSelectMetric={setSelectedMetric}
          regionData={regionData}
        />
      </Col>
      <Col xs={12}>
        <AMCReportTable reportData={tableData} reportDetails={reportDetails} queryDetails={queryDetails} />
      </Col>
    </>
  );
};

export default AMCGeoReport;
